<template>
  <div class="animated fadeIn">
    <h3>General Report</h3>
    <b-card v-for="(sample, index) in samples" no-body :key="index">
      <b-card-header>
        <span class="text-muted">
          <b>Sample ID</b>: {{ sample.number }} |
          <b>Type</b>: {{ sample.type }} |
          <b>Metric Units</b>: {{ sample.metric_unit }} |
          <b>Imperial Units</b>: {{ sample.imperial_unit }}
        </span>
      </b-card-header>
      <b-card-body class="p-0">
        <b-table class="mb-0" :items="sample.analyses" :fields="columns"  responsive bordered />
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
export default {
  name: "SubmissionGeneralReport",
    props: {
    samples: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      columns: [
        { key: "name", label: "Analysis" },
        { key: "dry_result", label: "Dry Basis Result" },
        { key: "wet_result", label: "Wet Basis Result" },
        { key: "unit", label: "Units" },
        { key: "metric_value", label: "Metric" },
        { key: "imperial_value", label: "Imperial" }
      ]
    }
  }
}
</script>